import { ModuleValueUniversal, SchemaModuleUniversal } from './module-universal';
import { JSONSchema } from '../types/json-schema';
import { FormComponent } from '../form.component';
import { Validator, FormProperty, PropertyGroup } from '../angular2-schema-form-shim';

import * as rawJSONSchemaModuleThoracicSurgery from '../../schemas/module-thoracic-surgery.json';

export class SchemaModuleThoracicSurgery extends SchemaModuleUniversal {
  schema: JSONSchema<ModuleValueUniversal>;

  constructor() {
    super();

    this.loadSchema( rawJSONSchemaModuleThoracicSurgery );
  }

}



// WEBPACK FOOTER //
// /var/www/schemas-forms/src/app/forms/module-thoracic-surgery.ts